import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModelTier } from '../../models/dossier.model';

@Component({
  selector: 'app-model-tier-slider',
  templateUrl: './model-tier-slider.component.html',
  styleUrls: ['./model-tier-slider.component.css'],
})
export class ModelTierSliderComponent implements OnInit {

  @Input() tiers: ModelTier[] = [];
  @Input() selectedModel = '';
  @Output() modelChange = new EventEmitter<string>();

  selectedIndex = 1; // default to Standard

  ngOnInit(): void {
    this.syncIndexFromModel();
  }

  /** Sync slider position when selectedModel input changes externally. */
  private syncIndexFromModel(): void {
    if (!this.tiers.length) return;
    const idx = this.tiers.findIndex(t => t.model === this.selectedModel);
    if (idx >= 0) {
      this.selectedIndex = idx;
    } else {
      // Default to "standard" tier
      const stdIdx = this.tiers.findIndex(t => t.key === 'standard');
      this.selectedIndex = stdIdx >= 0 ? stdIdx : 0;
    }
  }

  onSliderChange(event: Event): void {
    const value = +(event.target as HTMLInputElement).value;
    this.selectedIndex = value;
    if (this.tiers[value]) {
      this.modelChange.emit(this.tiers[value].model);
    }
  }

  get currentTier(): ModelTier | null {
    return this.tiers[this.selectedIndex] || null;
  }

  get maxIndex(): number {
    return Math.max(0, this.tiers.length - 1);
  }

  multiplierLabel(tier: ModelTier): string {
    if (tier.multiplier <= 0) return '';
    if (tier.multiplier < 1) return `${tier.multiplier}x`;
    return `${tier.multiplier}x`;
  }
}
